import { isAlcoholItem } from "./poolFulfillment";

type CatalogScope = { restaurantId?: string; locationId?: string };
type CatalogItem = CatalogScope & {
  name?: string; category?: string; section?: string; isAlcohol?: boolean;
};

/** Roma SH meal ordering is food + non-alcoholic drinks, never catering. */
export function isRegularOrderingCatalogItem(
  item: CatalogItem,
  scope: CatalogScope = item,
): boolean {
  if (scope.restaurantId !== "roma-kitchen" || scope.locationId !== "roma-kitchen-southern-highlands") return true;
  if (item.section === "catering" || item.category === "catering_trays") return false;
  // The owner menu explicitly identifies this bottle as non-alcoholic, but
  // the legacy seed categorizes it as beer without an isAlcohol override.
  const isKnownNonAlcoholicBeer = item.category === "beer" &&
    item.name === "Peroni Non-Alcoholic" && item.isAlcohol !== true;
  return isKnownNonAlcoholicBeer || !isAlcoholItem(item);
}

export function regularOrderingCatalogRejectionMessage(item: CatalogItem): string {
  const name = item.name?.trim();
  const prefix = name
    ? `${name} is not available for online pickup. `
    : "This item is not available for online pickup. ";
  return `${prefix}Catering uses the separate catering menu, and alcoholic drinks aren’t sold with online meal orders.`;
}

export function assertRegularOrderingCatalogItem(item: CatalogItem, scope: CatalogScope = item): void {
  if (!isRegularOrderingCatalogItem(item, scope)) {
    throw new Error(regularOrderingCatalogRejectionMessage(item));
  }
}
